export interface ConsentCopy {
    /** Accessible name of the banner region. */
    label: string;
    title: string;
    body: string;
    reject: string;
    accept: string;
    close: string;
    /** Shown when the banner is reopened, saying what the current choice is. */
    currentlyOn: string;
    currentlyOff: string;
    /** The footer link that reopens the banner. */
    settingsLink: string;
}

export const consentCopy: ConsentCopy = {
    label: 'Cookie consent',
    title: 'Analytics cookies',
    body: "I use Google Analytics to see which pages get read. It doesn't load until you choose, and you can change your mind any time from Cookie settings in the footer.",
    reject: 'Reject',
    accept: 'Accept',
    close: 'Close',
    currentlyOn: 'Currently on.',
    currentlyOff: 'Currently off.',
    settingsLink: 'Cookie settings',
};
